/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FuturesOptionMonthsByIdRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PositionsOptionMonthsMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdatePositionsOptionMonth
   * @request POST:/positionsOptionMonths-mass-updates
   * @secure
   */
  updatePositionsOptionMonth = (data: FuturesOptionMonthsByIdRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/positionsOptionMonths-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsPositionsOptionMonthsMassUpdates
   * @request OPTIONS:/positionsOptionMonths-mass-updates
   */
  optionsPositionsOptionMonthsMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/positionsOptionMonths-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
